import { Icon, IconButton, Input, InputGroup, InputRightElement, useColorModeValue } from '@chakra-ui/react';
import React, { useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { useRecoilState } from "recoil";
import searchTextAtom from "atoms/searchTextAtom";
export function SearchBar(props) {
	// Pass the computed styles into the `__css` prop
	const { variant, background, children, placeholder, borderRadius, ...rest } = props;
	// Chakra Color Mode

	const searchIconColor = useColorModeValue('gray.700', 'white');
	const inputBg = useColorModeValue('secondaryGray.300', 'navy.900');
	const inputText = useColorModeValue('gray.700', 'gray.100');

	const [searchText, setSearchText] = useRecoilState(searchTextAtom);

	const [inputs, setInputs] = useState({
		searchText: "",
	});


	function handleSearch() {
		setSearchText(inputs.searchText);
		let i = 1 + 2;
		return i;
	};

	return (
		<InputGroup w={{ base: '100%', md: '200px' }} {...rest}>
			<InputRightElement
				children={
					<IconButton
						bg='inherit'
						borderRadius='inherit'
						_hover='none'
						_active={{
							bg: 'inherit',
							transform: 'none',
							borderColor: 'transparent'
						}}
						_focus={{
							boxShadow: 'none'
						}}
						icon={<Icon as={FiSearch} color={searchIconColor} w='15px' h='15px' />}
						onClick={handleSearch}
					/>
				}
			/>
			<Input
				variant='search'
				fontSize='sm'
				bg={background ? background : inputBg}
				color={inputText}
				fontWeight='500'
				_placeholder={{ color: 'gray.400', fontSize: '14px' }}
				borderRadius={borderRadius ? borderRadius : '30px'}
				placeholder={placeholder ? placeholder : 'Search...'}
				type='text'
				value={inputs.username}
				onChange={(e) => setInputs((inputs) => ({ ...inputs, searchText: e.target.value }))}
			/>
		</InputGroup>
	);
}
